'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
require('../../extends-733dd656.js');
var React = require('react');
require('../../index-7124f64c.js');
require('../../taggedTemplateLiteral-f923b98d.js');
require('styled-components');
require('../../xstyled-styled-components.es-6e2bde7d.js');
require('../../extends-5ede7877.js');
require('../../unsupportedIterableToArray-f175acfa.js');
require('../../breakpoints-ee0a4ae5.js');
require('../../components/GlobalStyle/GlobalStyle.js');
require('../env/isTestEnv/isTestEnv.js');
require('../env/isBrowserEnv/isBrowserEnv.js');
require('../env/isProdEnv/isProdEnv.js');
require('../logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../theme-80c5a73f.js');
require('../../polished.esm-8ddeb0a5.js');
require('../../colorBuilder-8c1a81a8.js');
var components_NuDSProvider_NuDSProvider = require('../../components/NuDSProvider/NuDSProvider.js');
require('../i18n/maybeFormatMessage.js');
require('../i18n/maybeFormatPrefixedMessage.js');
var utils_intl_intlAriaAttrs = require('../intl/intlAriaAttrs.js');

function useIntlAriaAttrs(_ref) {
  var intlAriaKey = _ref.intlAriaKey;
  var nudsContext = React.useContext(components_NuDSProvider_NuDSProvider.NuDsContext);
  return utils_intl_intlAriaAttrs['default'](nudsContext, intlAriaKey);
}

exports.default = useIntlAriaAttrs;
//# sourceMappingURL=useIntlAriaAttrs.js.map
